"use client";
import { useEffect } from "react";

const exampleOriginal = `1
00:00:18,095 --> 00:00:21,845
Azmik-Ace Entertainment

2
00:00:27,695 --> 00:00:31,405
Kadokawa, Pony Canyon, Toho, Imagica, Asmik-Ace & Omega Project Present:

3
00:00:32,215 --> 00:00:35,855
Executive Producer Hara Masato

4
00:00:36,725 --> 00:00:40,495
Producers Kawai Shinya, Ichise Takashige, Sento Takenori

5
00:00:50,155 --> 00:00:53,695
R I N G

6
00:00:54,765 --> 00:00:58,495
Matsushima Nanako

7
00:00:58,495 --> 00:01:01,985
Nakatani Miki

8
00:01:01,985 --> 00:01:05,505
Sanada Hiroyuki

9
00:01:05,505 --> 00:01:08,975
From the Novel by Suzuki Koji (Kadokawa Shoten)

10
00:01:08,975 --> 00:01:12,455
Screenplay Takahashi Hiroshi

11
00:01:13,825 --> 00:01:17,465
Directed by Nakada Hideo

12
00:01:34,185 --> 00:01:38,785
Sunday, September 5th

13
00:01:39,265 --> 00:01:43,755
A grade-school boy was on holiday
down in Izu with his family.

14
00:01:44,575 --> 00:01:47,035
He wanted to go out and play...

15
00:01:47,035 --> 00:01:50,055
...but there was a TV show
he didn't want to miss.

16
00:01:50,905 --> 00:01:53,635
So he recorded it on
the VCR in their room.

17
00:01:53,915 --> 00:01:56,315
But the channels down there
are different from Tokyo's.

18
00:01:56,535 --> 00:02:00,315
No station there uses that channel,
so it should have been blank.

19
00:02:00,585 --> 00:02:04,705
But when he played it back at home,
there was a woman on the screen.

20
00:02:06,275 --> 00:02:07,925
You will die in one week, she said.

21
00:02:08,645 --> 00:02:11,365
The kid stopped the tape,
and then the phone rang.

22
00:02:12,065 --> 00:02:13,065
"You saw it."

23
00:02:14,745 --> 00:02:17,895
And a week later, the kid died!

24
00:02:28,715 --> 00:02:30,115
What's wrong, Tomoko?

25
00:02:34,455 --> 00:02:35,755
Who told you that?`;

const exampleGpt4o = `1
00:00:18,095 --> 00:00:21,845
Azmik-Ace Underholdning

2
00:00:27,695 --> 00:00:31,405
Kadokawa, Pony Canyon, Toho, Imagica, Asmik-Ace & Omega Project Presenterer:

3
00:00:32,215 --> 00:00:35,855
Utøvende produsent Hara Masato

4
00:00:36,725 --> 00:00:40,495
Produsenter Kawai Shinya, Ichise Takashige, Sento Takenori

5
00:00:50,155 --> 00:00:53,695
R I N G

6
00:00:54,765 --> 00:00:58,495
Matsushima Nanako

7
00:00:58,495 --> 00:01:01,985
Nakatani Miki

8
00:01:01,985 --> 00:01:05,505
Sanada Hiroyuki

9
00:01:05,505 --> 00:01:08,975
Fra romanen av Suzuki Koji (Kadokawa Shoten)

10
00:01:08,975 --> 00:01:12,455
Manus av Takahashi Hiroshi

11
00:01:13,825 --> 00:01:17,465
Regissert av Nakada Hideo

12
00:01:34,185 --> 00:01:38,785
Søndag, 5. september

13
00:01:39,265 --> 00:01:43,755
En skolegutt var på ferie i Izu med familien sin.

14
00:01:44,575 --> 00:01:47,035
Han ville gå ut og leke...

15
00:01:47,035 --> 00:01:50,055
...men det var et TV-program han ikke ville gå glipp av.

16
00:01:50,905 --> 00:01:53,635
Så han spilte det inn på videoopptakeren på rommet deres.

17
00:01:53,915 --> 00:01:56,315
Men kanalene der nede er forskjellige fra de i Tokyo.

18
00:01:56,535 --> 00:02:00,315
Ingen stasjon der bruker den kanalen, så den burde ha vært blank.

19
00:02:00,585 --> 00:02:04,705
Men da han spilte det hjemme,\nvar det en kvinne på skjermen.

20
00:02:06,275 --> 00:02:07,925
Du vil dø om en uke, sa hun.

21
00:02:08,645 --> 00:02:11,365
Gutten stoppet båndet,\nog så ringte telefonen.

22
00:02:12,065 --> 00:02:13,065
"Du så det."

23
00:02:14,745 --> 00:02:17,895
Og en uke senere døde gutten!

24
00:02:28,715 --> 00:02:30,115
Hva er i veien, Tomoko?

25
00:02:34,455 --> 00:02:35,755
Hvem fortalte deg det?
`;

const exampleGpt41 = `1
00:00:18,095 --> 00:00:21,845
Azmik-Ace Entertainment

2
00:00:27,695 --> 00:00:31,405
Kadokawa, Pony Canyon, Toho, Imagica, Asmik-Ace & Omega Project presenterer:

3
00:00:32,215 --> 00:00:35,855
Administrerende produsent Hara Masato

4
00:00:36,725 --> 00:00:40,495
Produsenter Kawai Shinya, Ichise Takashige, Sento Takenori

5
00:00:50,155 --> 00:00:53,695
R I N G

6
00:00:54,765 --> 00:00:58,495
Matsushima Nanako

7
00:00:58,495 --> 00:01:01,985
Nakatani Miki

8
00:01:01,985 --> 00:01:05,505
Sanada Hiroyuki

9
00:01:05,505 --> 00:01:08,975
Basert på romanen av Suzuki Koji (Kadokawa Shoten)

10
00:01:08,975 --> 00:01:12,455
Manus Takahashi Hiroshi

11
00:01:13,825 --> 00:01:17,465
Regi Nakada Hideo

12
00:01:34,185 --> 00:01:38,785
Søndag 5. september

13
00:01:39,265 --> 00:01:43,755
En gutt i barneskolen var på ferie
nede i Izu med familien sin.

14
00:01:44,575 --> 00:01:47,035
Han ville gå ut og leke...

15
00:01:47,035 --> 00:01:50,055
...men det var et TV-program
han ikke ville gå glipp av.

16
00:01:50,905 --> 00:01:53,635
Så han tok det opp på
videospilleren på rommet deres.

17
00:01:53,915 --> 00:01:56,315
Men kanalene der nede
er annerledes enn i Tokyo.

18
00:01:56,535 --> 00:02:00,315
Ingen stasjon der bruker den kanalen,
så det skulle vært tomt.

19
00:02:00,585 --> 00:02:04,705
Men da han spilte den av hjemme,
var det en kvinne på skjermen.

20
00:02:06,275 --> 00:02:07,925
Du vil dø om en uke, sa hun.

21
00:02:08,645 --> 00:02:11,365
Gutten stoppet kassetten,
og så ringte telefonen.

22
00:02:12,065 --> 00:02:13,065
"Du så det."

23
00:02:14,745 --> 00:02:17,895
Og en uke senere døde gutten!

24
00:02:28,715 --> 00:02:30,115
Hva er galt, Tomoko?

25
00:02:34,455 --> 00:02:35,755
Hvem fortalte deg det?
`;

const exampleGpt4oMini = `1
00:00:18,095 --> 00:00:21,845
Azmik-Ace Underholdning

2
00:00:27,695 --> 00:00:31,405
Kadokawa, Pony Canyon, Toho, Imagica, Asmik-Ace & Omega Project Presenterer:

3
00:00:32,215 --> 00:00:35,855
Utførledende produsent Hara Masato

4
00:00:36,725 --> 00:00:40,495
Produsenter Kawai Shinya, Ichise Takashige, Sento Takenori

5
00:00:50,155 --> 00:00:53,695
R I N G

6
00:00:54,765 --> 00:00:58,495
Matsushima Nanako

7
00:00:58,495 --> 00:01:01,985
Nakatani Miki

8
00:01:01,985 --> 00:01:05,505
Sanada Hiroyuki

9
00:01:05,505 --> 00:01:08,975
Fra romanen av Suzuki Koji (Kadokawa Shoten)

10
00:01:08,975 --> 00:01:12,455
Manus Takahashi Hiroshi

11
00:01:13,825 --> 00:01:17,465
Regissert av Nakada Hideo

12
00:01:34,185 --> 00:01:38,785
Søndag, 5. september

13
00:01:39,265 --> 00:01:43,755
En gutt fra barneskolen var på ferie
gjennom Izu med familien sin.

14
00:01:44,575 --> 00:01:47,035
Han ville gå ut og leke...

15
00:01:47,035 --> 00:01:50,055
...men det var et TV-program
han ikke ville gå glipp av.

16
00:01:50,905 --> 00:01:53,635
Så han tok det opp på
VCR-en i rommet deres.

17
00:01:53,915 --> 00:01:56,315
Men kanalene der nede
er forskjellige fra Tokyos.

18
00:01:56,535 --> 00:02:00,315
Ingen stasjon der bruker den kanalen,
så den burde vært blank.

19
00:02:00,585 --> 00:02:04,705
Men da han spilte det tilbake hjemme,
vart det en kvinne på skjermen.

20
00:02:06,275 --> 00:02:07,925
"Du vil dø om en uke," sa hun.

21
00:02:08,645 --> 00:02:11,365
Ungen stoppet båndet,
og så ringte telefonen.

22
00:02:12,065 --> 00:02:13,065
"Du så det."

23
00:02:14,745 --> 00:02:17,895
Og en uke senere døde ungen!

24
00:02:28,715 --> 00:02:30,115
Hva er galt, Tomoko?

25
00:02:34,455 --> 00:02:35,755
Hvem sa deg det?
`;

const exampleGpt41Mini = `1
00:00:18,095 --> 00:00:21,845
Asmik-Ace Entertainment

2
00:00:27,695 --> 00:00:31,405
Kadokawa, Pony Canyon, Toho, Imagica, Asmik-Ace & Omega Project presenterer:

3
00:00:32,215 --> 00:00:35,855
Eksekutiv produsent Hara Masato

4
00:00:36,725 --> 00:00:40,495
Produsenter Kawai Shinya, Ichise Takashige, Sento Takenori

5
00:00:50,155 --> 00:00:53,695
R I N G

6
00:00:54,765 --> 00:00:58,495
Matsushima Nanako

7
00:00:58,495 --> 00:01:01,985
Nakatani Miki

8
00:01:01,985 --> 00:01:05,505
Sanada Hiroyuki

9
00:01:05,505 --> 00:01:08,975
Fra romanen av Suzuki Koji (Kadokawa Shoten)

10
00:01:08,975 --> 00:01:12,455
Manus Takahashi Hiroshi

11
00:01:13,825 --> 00:01:17,465
Regissert av Nakada Hideo

12
00:01:34,185 --> 00:01:38,785
Søndag 5. september

13
00:01:39,265 --> 00:01:43,755
En barneskolegutt var på ferie\n nede i Izu med familien sin.

14
00:01:44,575 --> 00:01:47,035
Han ville gå ut og leke...

15
00:01:47,035 --> 00:01:50,055
...men det var et TV-program\nhan ikke ville gå glipp av.

16
00:01:50,905 --> 00:01:53,635
Så han spilte det inn på\n videospilleren på rommet deres.

17
00:01:53,915 --> 00:01:56,315
Men kanalene der nede\ner forskjellige fra Tokyos.

18
00:01:56,535 --> 00:02:00,315
Ingen stasjon der bruker den kanalen,\ndet skulle derfor ha vært tomt.

19
00:02:00,585 --> 00:02:04,705
Men når han spilte det av hjemme,
vistes det en kvinne på skjermen.

20
00:02:06,275 --> 00:02:07,925
Du vil dø om en uke, sa hun.

21
00:02:08,645 --> 00:02:11,365
Ungen stoppet båndet,
og så ringte telefonen.

22
00:02:12,065 --> 00:02:13,065
"Du så det."

23
00:02:14,745 --> 00:02:17,895
Og en uke senere døde ungen!

24
00:02:28,715 --> 00:02:30,115
Hva er galt, Tomoko?

25
00:02:34,455 --> 00:02:35,755
Hvem sa det til deg?
`;

export const TranslationExamples = () => {
  // Synchronize scrolling across all translation containers
  useEffect(() => {
    const scrollContainers = document.querySelectorAll('[data-scroll-group="translations"]');

    const handleScroll = (event: Event) => {
      const target = event.target as HTMLElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      const scrollPercentage = scrollTop / (scrollHeight - clientHeight);

      scrollContainers.forEach((container) => {
        if (container !== target) {
          const element = container as HTMLElement;
          const elementScrollHeight = element.scrollHeight;
          const elementClientHeight = element.clientHeight;
          const newScrollTop = scrollPercentage * (elementScrollHeight - elementClientHeight);
          element.scrollTop = newScrollTop;
        }
      });
    };

    scrollContainers.forEach((container) => {
      container.addEventListener("scroll", handleScroll);
    });

    return () => {
      scrollContainers.forEach((container) => {
        container.removeEventListener("scroll", handleScroll);
      });
    };
  }, []);

  return (
    <div className="mt-16 border-t pt-12">
      <h2 className="scroll-m-20 text-3xl font-bold tracking-tight mb-8">Translation Examples</h2>
      <p className="text-muted-foreground mb-8">
        See how different GPT models translate the same subtitle file. This example shows a scene
        from &ldquo;The Ring&rdquo; translated from English to Norwegian.
      </p>

      <div className="space-y-6">
        {/* Model Comparisons */}
        <div className="space-y-4">
          <h3 className="text-lg font-semibold">Translations</h3>

          <div className="grid gap-4 md:grid-cols-3 lg:grid-cols-5">
            {/* Original Text */}
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <h4 className="font-medium">Original</h4>
                <span className="text-xs bg-gray-100 text-gray-800 px-2 py-1 rounded">English</span>
              </div>
              <div
                className="bg-muted p-4 rounded-lg h-96 overflow-y-auto scroll-sync"
                data-scroll-group="translations"
              >
                <pre className="whitespace-pre-wrap text-sm font-mono">{exampleOriginal}</pre>
              </div>
            </div>

            {/* GPT-4o */}
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <h4 className="font-medium">GPT-4o</h4>
                <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">
                  Fast & Good
                </span>
              </div>
              <div
                className="bg-muted p-4 rounded-lg h-96 overflow-y-auto scroll-sync"
                data-scroll-group="translations"
              >
                <pre className="whitespace-pre-wrap text-sm font-mono">{exampleGpt4o}</pre>
              </div>
            </div>

            {/* GPT-4.1 */}
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <h4 className="font-medium">GPT-4.1</h4>
                <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                  Best Quality
                </span>
              </div>
              <div
                className="bg-muted p-4 rounded-lg h-96 overflow-y-auto scroll-sync"
                data-scroll-group="translations"
              >
                <pre className="whitespace-pre-wrap text-sm font-mono">{exampleGpt41}</pre>
              </div>
            </div>

            {/* GPT-4o-mini */}
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <h4 className="font-medium">GPT-4o-mini</h4>
                <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded">
                  Fast & Decent
                </span>
              </div>
              <div
                className="bg-muted p-4 rounded-lg h-96 overflow-y-auto scroll-sync"
                data-scroll-group="translations"
              >
                <pre className="whitespace-pre-wrap text-sm font-mono">{exampleGpt4oMini}</pre>
              </div>
            </div>

            {/* GPT-4.1-mini */}
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <h4 className="font-medium">GPT-4.1-mini</h4>
                <span className="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded">
                  Fast & Decent
                </span>
              </div>
              <div
                className="bg-muted p-4 rounded-lg h-96 overflow-y-auto scroll-sync"
                data-scroll-group="translations"
              >
                <pre className="whitespace-pre-wrap text-sm font-mono">{exampleGpt41Mini}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
